import { User } from '@modules/auth/hooks/types'

import { PendoAllProductsPageEventType } from '../types'
import { getEventDefaultInfo } from '../utils'

const descriptionMap: Record<PendoAllProductsPageEventType, string> = {
  [PendoAllProductsPageEventType.EventSelected]: 'Event selected on all products page',
}

export const prepareAllProductPageEventData = ({
  eventType,
  user,
  companyId,
  previousEventId,
  newEventId,
}: {
  eventType: PendoAllProductsPageEventType
  user?: User | null
  companyId: number
  previousEventId: number
  newEventId: number
}) => {
  return {
    ...getEventDefaultInfo(user),
    previousEventId,
    newEventId,
    eventType: descriptionMap[eventType],
    companyId,
  }
}
